import type { LockfileRefresher, ProjectDeployGuard } from '@cli-types/next-adapter/init.js'
import { guardBetterstartConfig } from './guard-betterstart-config.js'
import { guardPackageJson } from './guard-package-json.js'
import { guardPnpmLockfile } from './guard-pnpm-lockfile.js'
import { runPnpmLockfileOnly } from './run-pnpm-lockfile-only.js'

/** Remote build machines cannot resolve `workspace:`/`link:`/`file:` specs or the unpublished CLI dep. */
export async function guardProjectForDeploy(
  cwd: string,
  refreshLockfile: LockfileRefresher = runPnpmLockfileOnly
): Promise<ProjectDeployGuard> {
  const restores: Array<() => void> = []
  const { localSpecDeps, removedCliDep } = guardPackageJson(cwd, restores)
  guardBetterstartConfig(cwd, restores)
  const lockfile = removedCliDep
    ? await guardPnpmLockfile(cwd, restores, refreshLockfile)
    : 'not-needed'

  return {
    localSpecDeps,
    lockfile,
    restore() {
      for (const restoreFile of restores) {
        try {
          restoreFile()
        } catch {}
      }
    }
  }
}
